import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=d28063bc&scoped=true&"
import script from "./SignUpModal.vue?vue&type=script&lang=js&"
export * from "./SignUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=d28063bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28063bc",
  null
  
)

export default component.exports